module.exports = __webpack_public_path__ + "static/img/register-btn.66387ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/register-btn.png
// module id = EfH6
// module chunks = 1